mobileSize = 1199;
// Countdown
function placeCountdown() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('#siteInfoBannerWidget').insertAfter('.bottom-header .container');
  } else {
    $('#siteInfoBannerWidget').prependTo('.countdown-main');
  }
}

$(document).ready(function () {
  
  // Check Window Size
  const windowSize = $(window).width();
  if (windowSize < 1199) {
    $('body')
    .addClass('saffireMobileSize')
    .removeClass('saffireLargeSize');
  } if (windowSize > 1199) {
    $('body').removeClass('saffireMobileSize');
  }

  // Countdown
  placeCountdown();

   // footer logo
   $('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');
   $( ".footerItems1 a" ).removeClass( "button" );
   $(".generalmessage").prependTo(".header");
   //prepend general message into header
   if ( $("body").hasClass("generalMessageOn") ) {
       $(".generalmessage").prependTo(".header");
   }
   
   //Subscribe
    const fes = $('.subscribe-container .emailSignup');
    fes.find('.emailSubmitButton').text('join');
    fes.find('.inputFieldTextbox').val('');
    fes.find('.inputFieldTextbox').attr('placeholder', 'Enter email');
    $('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + '/images/saffire-logo.png');

});

$(window).load(function(){
  $('.york-expo-center a.header-logo').attr('href','https://yorkstatefair.saffire.com/p/york-expo-center');
  $('.york-expo-center .footer a.york-expo').attr('href','https://yorkstatefair.saffire.com');
    // Weather Bug
    setInterval(function() {
      var str = $('#weatherBugDescription').text();
      var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
      if(!weatherBugSet && str != ''){
        $('#weatherBugWidget').addClass('weatherBugSet');
          var findSpace = str.lastIndexOf(' ');
          var stringLength = str.length;
          var res = str.substring(findSpace, stringLength);
          var start = str.substring(0, findSpace);
          $('#weatherBugDescription').html('<span class="weatherDescriptive">'+start+'</span>'+res);
          $('#weatherBugWidget').css('visibility', 'visible');
      }
    },12);
});


$(window).resize(function(){
  // Countdown
  placeCountdown();
});